import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@mui/material";
import { WarningAmber as WarningIcon } from '@mui/icons-material';

export const DisableBookingConfirmation = ({ confirmOpen, setConfirmOpen, handleSave }: {
    confirmOpen: boolean;
    setConfirmOpen: (open: boolean) => void;
    handleSave: () => void;
}) => {
    return (
        <Dialog
            open={confirmOpen}
            onClose={() => setConfirmOpen(false)}
            aria-labelledby="confirm-dialog-title"
            PaperProps={{ sx: { borderRadius: 3, p: 1, maxWidth: 600 } }}
        >
            <DialogTitle id="confirm-dialog-title" sx={{ display: 'flex', alignItems: 'center', gap: 1.5, fontWeight: 600 }}>
                <WarningIcon color="primary" />
                Booking Disabled
            </DialogTitle>
            <DialogContent>
                <DialogContentText variant="body1" color="text.primary">
                    New appointments cannot be scheduled when booking is disabled. Are you sure you want to save these settings?
                </DialogContentText>
            </DialogContent>
            <DialogActions sx={{ p: 2, gap: 1 }}>
                <Button onClick={() => setConfirmOpen(false)} color="inherit" sx={{ textTransform: 'none' }}>Cancel</Button>
                <Button
                    onClick={() => {
                        setConfirmOpen(false);
                        handleSave();
                    }}
                    variant="contained"
                    color="primary"
                    autoFocus
                    sx={{ borderRadius: '20px', px: 3, textTransform: 'none' }}
                >
                    Save Anyway
                </Button>
            </DialogActions>
        </Dialog>
    )
}
